import React from "react";
import SeoForm from "./components/SeoForm";

function AddProductSeo() {
  return <SeoForm entityType="product" />;
}

export default AddProductSeo;
